define( function() {
	"use strict";

	// All support tests are defined in their respective modules.
	return {};
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/support.js
// module id = 10
// module chunks = 0